import { useState } from "react";
import msg from "components/string-table";
import { Accordion, Icon } from "main";
import { generateSwingSupportURL } from "swing-utils";

import styles from "./SwingHeroInEligible.module.css";

type SwingHeroInEligibleProps = {
  isHourly: boolean;
  onClick?: () => void;
};

export function SwingHeroInEligible(props: SwingHeroInEligibleProps) {
  const { isHourly, onClick } = props;

  const [isExpanded, setIsExpanded] = useState(true);

  /********* Constants ********/
  const supportArticleUrl = generateSwingSupportURL(
    isHourly
      ? msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_SUPPORT_ARTICLE_LINK_W2")
      : msg("SWING_HERO_ELIGIBLE_NOT_YET_ELIGIBLE_SUPPORT_ARTICLE_LINK_1099"),
  );

  /********* Render ********/
  return (
    <div className={styles.container}>
      <Accordion
        title={msg("SWING_HERO_YOUR_STATUS")}
        isOpen={isExpanded}
        onToggle={() => setIsExpanded(!isExpanded)}
      >
        <>
          <p className={styles.title}>{msg("SWING_HERO_SWING_SUB")}</p>
          <div className={styles.divider} />
          <p>{msg("SWING_HERO_INELIGIBLE_STATUS_SUB_TEXT")}</p>
          <div className={styles.divider} />
          <div>
            <p className={styles.listTitle}>{msg("SWING_HERO_INELIGIBLE_LIST_TITLE")}</p>
            <ul className={styles.list}>
              <ListItem>{msg("SWING_HERO_INELIGIBLE_LIST_FIRST_ITEM")}</ListItem>
              <ListItem>{msg("SWING_HERO_INELIGIBLE_LIST_SECOND_ITEM")}</ListItem>
              <ListItem>
                {msg("SWING_HERO_INELIGIBLE_LIST_SKILL_BUILDERS_PREFIX")}{" "}
                <a
                  href="#"
                  style={{ textDecoration: "underline" }}
                  onClick={(e) => {
                    e.preventDefault();
                    onClick?.();
                  }}
                >
                  {msg("SWING_HERO_INELIGIBLE_LIST_SKILL_BUILDERS_BUTTON")}
                </a>{" "}
                {msg("SWING_HERO_INELIGIBLE_LIST_SKILL_BUILDERS_SUFFIX")}
              </ListItem>
            </ul>
          </div>
          <div className={styles.divider} />
          <p>
            <a
              href={generateSwingSupportURL("/hc/en-us/requests/new")}
              target="_blank"
              rel="noreferrer"
            >
              {msg("SWING_HERO_INELIGIBLE_CONTACT_SUPPORT_START")}
            </a>{" "}
            {msg("SWING_HERO_INELIGIBLE_CONTACT_SUPPORT_END")}
          </p>
          <div className={styles.divider} />
          <p className={styles.learnMore}>
            {`${msg("SWING_HERO_LEARN_MORE_ABOUT")} `}
            <a href={supportArticleUrl} target="_blank" rel="noreferrer">
              {msg("SWING_HEROES")}
            </a>
            .
          </p>
        </>
      </Accordion>
    </div>
  );
}

/********* Helper Components ********/
function ListItem(props: { children: React.ReactNode }) {
  const { children } = props;
  return (
    <li className={styles.listItem}>
      <Icon name="Check Circle" />
      <span className={styles.listItemText}>{children}</span>
    </li>
  );
}
